import React from 'react';
import { Link } from 'react-router-dom';
import { Grid } from 'ceci-ui';
import { PageContainer } from '../../components/Page';
import OnboardingCard from './OnboardingCard';
import SummaryCard from './SummaryCard';
import ActivationAlert from './ActivationAlert';

function HomePage() {
  return (
    <PageContainer>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <SummaryCard />
        </Grid>
        <Grid item xs={9}>
          <h1>Seja bem-vindo ao Plipag</h1>
          <p>O PLI é o jeito mais fácil de controlar seus clientes e automatizar as suas cobranças, aumentando a sua eficiência e a satisfação dos seus clientes.</p>

          <Grid container spacing={4}>
            <Grid item xs={4}>
              <OnboardingCard
                done
                step={1}
                title="Configure sua conta"
                content="Esse é o primeiro passo para começar a emitir cobranças. Cadastre os dados da sua empresa e configure suas prferência."
                buttonProps={{
                  component: Link,
                  children: 'Configurar',
                  to: '/configurar'
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <OnboardingCard
                step={2}
                title="Cadastre seus clientes"
                content="Cadastre seus clientes e, se quiser, separe-os por grupos para otimizar a emissão de cobranças."
                buttonProps={{
                  component: Link,
                  children: 'Cadastrar',
                  to: '/cadastrar'
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <OnboardingCard
                disabled
                step={3}
                title="Emita uma cobrança"
                content="Com seus clientes cadastrados, agora você pode começar a emitir cobranças. Aproveite para configurar sua régua de cobrança."
                buttonProps={{
                  component: Link,
                  children: 'Emitir',
                  to: '/emitir'
                }}
              />
            </Grid>
          </Grid>
          <ActivationAlert />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default HomePage;
